import React from 'react';

import * as helpers from './helpers';

const InfinityIcon = ({
  color,
  width = 38,
  height = 17,
  ...props
}: {
  color: string,
  width: number,
  height: number,
}) => (
  <svg
    {...helpers.getSvgDimensionsProps({ width, height })}
    {...helpers.getViewBoxProperty({ width, height })}
    {...props}>
    <path
      d="M29.9986 0.437881C24.9826 0.437881 20.8324 4.40973 19 6.49379C17.1677 4.4098 13.0174 0.437881 8.0016 0.437881C3.58952 0.437881 0 4.03496 0 8.45625C0 12.8775 3.58952 16.4745 8.00152 16.4745C13.0174 16.4745 17.1676 12.5027 19 10.4188C20.8323 12.5028 24.9826 16.4745 29.9986 16.4745C34.4106 16.4745 38 12.8775 38 8.45625C38 4.03496 34.4106 0.437881 29.9986 0.437881ZM15.5 11C12.5019 13.5559 9.03106 14.5 7.5 14.5C4.45443 14.5 1.97672 11.5082 1.97672 8.45625C1.97672 5.40435 4.45451 2.49999 7.5 2.49999C11.7607 2.49999 16.599 6.80498 18 8.45625C17.4839 9.06605 16.5744 10.084 15.5 11ZM29.9986 14.5C25.7391 14.5 21.402 10.1083 20 8.45625C21.4019 6.80416 25.7391 2.49999 29.9986 2.49999C33.0441 2.49999 36 5.40435 36 8.45625C36 11.5082 33.044 14.5 29.9986 14.5Z"
      fill={color}
    />
  </svg>
);

export default InfinityIcon;
